/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalSystemSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalSystemSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { settingsAutomationRoute } from '@jira/router-routes__settings-automation-routes/src/settingsAutomationRoute.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import type { Route } from '@atlassian/react-resource-router';
import Automation, { LazyGlobalAutomation } from './ui/index.tsx';

export const settingsAutomationRouteEntry: Route = createEntry(settingsAutomationRoute, () => ({
	group: 'global-settings',
	// eslint-disable-next-line no-restricted-syntax
	component: Automation,
	layout: globalSettingsLayout,

	navigation: {
		sidebarId: SidebarIdGlobalSystemSettings,
		menuId: MenuIdSettings,
	},

	resources: [
		...getNavigationResources(),
		navigationSidebarGlobalResource,
		conditionalPostOfficeJiraTopBannerResource,
	],

	forPaint: [LazyAtlassianNavigation, LazyGlobalAutomation],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
